import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { WebSocketProvider } from './context/socketContext';

// Create the theme
const theme = createTheme();

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <WebSocketProvider>
      <App />
      </WebSocketProvider>
    </ThemeProvider>
  </Provider>
);
